import { render, staticRenderFns } from "./CitasCalendario.vue?vue&type=template&id=3be9a968&scoped=true"
import script from "./CitasCalendario.vue?vue&type=script&lang=js"
export * from "./CitasCalendario.vue?vue&type=script&lang=js"
import style0 from "./CitasCalendario.vue?vue&type=style&index=0&id=3be9a968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be9a968",
  null
  
)

export default component.exports